import type { AxiosResponse } from 'axios';
import axios from 'axios';

import type { OrderStatus } from '@montugroup/circuit-shared/types/index';

import settings from '../constants/constants';

const API_URL = `${settings.url}/order`;

const getOrderStatus = async (): Promise<AxiosResponse<OrderStatus[]>> => axios.get(`${API_URL}/order-status`);

export const OrderService = {
  getOrderStatus,
};
